import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import PostFertilizerRequirement from '.';

interface IPostFertilizerRequirementProps {
  onSuccess?: (response: IAddedAdvertisementResponse) => void;
}

const usePostFertilizerRequirement = ({
  onSuccess,
}: IPostFertilizerRequirementProps) => {
  const {mutate, isLoading} = useMutation({
    mutationFn: (payload: IFertilizerRequirementPayload) => {
      return PostFertilizerRequirement(payload);
    },
    onSuccess: data => {
      onSuccess && onSuccess(data);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {mutate, isLoading};
};

export {usePostFertilizerRequirement};
